// extracted by mini-css-extract-plugin
module.exports =  {"contactsPlaceholder":"contactsPlaceholder___p2aAW","placeholderTitle":"placeholderTitle___ibFRk","placeholderRow":"placeholderRow___GPvSK","mobile":"mobile___PIIiY"};